export default {
    CREATE_SELF_SERVICE_TEMPLATE: "createSelfServiceTemplate",
    GET_SELF_SERVICE_TEMPLATE: "getSelfServiceTemplate",
    POST_GENERATE_PREVIEW: "postGeneratePreview",
    GET_HISTORY: "getHistory",
    GET_HISTORICAL_DATA: "getHistoricalData",
    POST_RASTER_TEMPLATES: "postRasterTemplates"
}